import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { getOrderIdByRequest } from '../../../shared/api/orders.api'
import { CreateOrderButton } from './CreateOrderButton'

/**
 * Панель входа в Блок 2 из карточки заявки: появляется, когда у заявки есть
 * позиции в статусе «Счёт» (ORDERED) или «Заказ» (ORDER_CONFIRMED).
 *
 * С 12.10.2026 заказ оформляется сам отметкой «Счёт» — панель ведёт в него.
 * Кнопка выгрузки шаблона остаётся для заявок, по которым заказа ещё нет
 * (старые сделки до разового создания заказов).
 */
export function OrderEntryPanel({
  requestId,
  sellerEntityId,
  items,
  userRole,
}: {
  requestId: string
  /** Юрлицо продажи заявки — по умолчанию в окне счёта. */
  sellerEntityId?: string | null
  items: Array<{ status: string }>
  userRole?: string
}) {
  const canCreate =
    userRole === 'ADMIN' || userRole === 'MANAGER' || userRole === 'ROP' || userRole === 'ASSISTANT'
  const hasOrdered = items.some((i) => i.status === 'ORDERED' || i.status === 'ORDER_CONFIRMED')
  const order = useQuery({
    queryKey: ['order-by-request', requestId],
    queryFn: () => getOrderIdByRequest(requestId),
    enabled: canCreate && hasOrdered,
  })
  if (!canCreate || !hasOrdered) return null

  const box =
    'flex flex-wrap items-center justify-between gap-2 rounded-xl border border-gray-200 bg-white p-4'
  if (order.data) {
    return (
      <div className={box}>
        <span className="text-sm text-gray-700">
          По позициям «Счёт» оформлен заказ: счета, оплаты, условия оплаты и шаблон счёта для 1С:УНФ
          — в нём.
        </span>
        <Link
          to={`/orders/${order.data}`}
          className="rounded-lg bg-emerald-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-emerald-700"
        >
          Открыть заказ
        </Link>
      </div>
    )
  }
  if (order.isLoading) return null
  return (
    <div className={box}>
      <span className="text-sm text-gray-700">
        По позициям «Счёт» можно оформить заказ и выгрузить шаблон счёта для 1С:УНФ.
      </span>
      <CreateOrderButton requestId={requestId} defaultEntityId={sellerEntityId} />
    </div>
  )
}
